const reasons = [
  { icon: 'ri-search-eye-line', title: 'Диагностика до обучения', desc: 'Сначала определяем реальные задачи компании и уровень участников, а не начинаем с готового шаблона.' },
  { icon: 'ri-file-list-3-line', title: 'Реальные рабочие ситуации', desc: 'Разбираем ситуации, с которыми руководители и наставники сталкиваются в ежедневной работе.' },
  { icon: 'ri-tools-line', title: 'Практика', desc: 'Навыки отрабатываются через упражнения, ролевые ситуации и рабочие кейсы, а не просто обсуждаются.' },
  { icon: 'ri-settings-3-line', title: 'Адаптация', desc: 'Программа подстраивается под отрасль, структуру компании и задачи участников.' },
  { icon: 'ri-rocket-2-line', title: 'Внедрение', desc: 'Инструменты переносятся в ежедневную практику руководителей и наставников.' },
  { icon: 'ri-user-heart-line', title: 'Сопровождение', desc: 'При необходимости после обучения разбираются реальные ситуации наставников и руководителей.' },
  { icon: 'ri-file-copy-2-line', title: 'Систематизация', desc: 'При необходимости создаются алгоритмы, чек-листы и другие инструменты, которые компания сможет использовать дальше.' },
];

export default function WhyProgramsWork() {
  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Почему наши программы работают
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Почему обучение не заканчивается тренингом, а приводит к изменению практики наставничества и развития сотрудников
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {reasons.map((r) => (
            <div key={r.title} className="bg-gray-50 rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${r.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{r.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 bg-teal-50 rounded-xl border border-teal-200 p-6 md:p-8 max-w-4xl mx-auto text-center">
          <p className="text-base text-teal-800 leading-relaxed font-semibold">
            Наша задача — не просто научить руководителя наставничеству, а помочь ему развивать сотрудников в реальной рабочей практике.
          </p>
        </div>
      </div>
    </section>
  );
}